import { makeStyles, tokens } from "@coreai/fluentui-react";

export const useTriggerWorkflowDialogStyles = makeStyles({
  dialogSurface: {
    maxWidth: '650px',
    width: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  triggerSelect: {
    width: '100%',
  },
  triggerInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    padding: tokens.spacingVerticalS,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusMedium,
  },
  triggerInfoRow: {
    display: 'flex',
    gap: tokens.spacingHorizontalS,
  },
  triggerInfoLabel: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    minWidth: '80px',
  },
  triggerInfoValue: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
    fontFamily: tokens.fontFamilyMonospace,
    wordBreak: 'break-all',
  },
  triggerInfoUrlValue: {
    flex: 1,
    minWidth: 0,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
    fontFamily: tokens.fontFamilyMonospace,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'default',
  },
  payloadSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  methodSelect: {
    width: '120px',
  },
  keyValueSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  keyValueRow: {
    display: 'flex',
    gap: tokens.spacingHorizontalS,
    alignItems: 'center',
  },
  keyInput: {
    flex: 1,
    minWidth: '100px',
  },
  valueInput: {
    flex: 2,
  },
  deleteButton: {
    minWidth: 'auto',
    padding: tokens.spacingHorizontalXS,
  },
  addButton: {
    alignSelf: 'flex-start',
  },
  jsonEditor: {
    width: '100%',
  },
  textareaBody: {
    width: '100%',
    minHeight: '150px',
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
  },
  contentTypeSelect: {
    width: '150px',
  },
  noPayloadMessage: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    fontStyle: 'italic',
  },
  loadingTriggers: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacingVerticalXXL,
  },
  accordion: {
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusMedium,
  },
  errorBar: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: tokens.spacingHorizontalS,
    padding: tokens.spacingVerticalS,
    backgroundColor: tokens.colorPaletteRedBackground1,
    borderRadius: tokens.borderRadiusMedium,
    border: `1px solid ${tokens.colorPaletteRedBorder1}`,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorPaletteRedForeground1,
  },
  accordionPanel: {
    padding: tokens.spacingVerticalM,
    paddingTop: tokens.spacingVerticalS,
  },
  dialogCloseButton: {
    position: 'absolute' as const,
    right: tokens.spacingHorizontalM,
    top: tokens.spacingVerticalM,
  },
  errorIcon: {
    flexShrink: 0,
    fontSize: tokens.fontSizeBase400,
  },
  mockToggleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusMedium,
  },
  mockToggleLabel: {
    flex: 1,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground2,
  },
  validationErrorList: {
    margin: `${tokens.spacingVerticalXS} 0 0 0`,
    paddingLeft: tokens.spacingHorizontalL,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
  },
  validationErrorItem: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
    wordBreak: 'break-word',
  },
  validationErrorNode: {
    fontWeight: tokens.fontWeightSemibold,
    fontFamily: tokens.fontFamilyMonospace,
  },
  validationErrorToggle: {
    marginTop: tokens.spacingVerticalXS,
    paddingLeft: 0,
    minWidth: 'auto',
  },
});